<template>
  <div class="menu">
    <div class="wrapper">
      <!-- Menu top section -->
      <!-- <div class="menu__top">
        <div v-if="!isSearchwide" class="menu__top--section menu__top--section-list">
          <app-link v-for="link in topList" :type="link.type" :id="link.id" :key="link.id" class="menu__top--section-list-item link-unstyle">{{ link.text }}</app-link>
        </div>
      </div> -->

      <!-- Menu main section -->
      <div v-if="!isSearchwide" class="menu__main">
        <div class="menu__main--sections">
          <div v-for="list in mainList" :key="list.id" class="menu__main--sections-section">
            <h3 class="menu__title" aria-label="Menu title">
              <app-link :id="list.id" :empty="true" :type="list.type">
                {{ list.name }}
              </app-link>
            </h3>
            <ul>
              <li v-for="link in list.links" :key="link.text">
                <app-link :id="link.id" :class="link.class" :type="link.type" :title="link.text" v-html="link.text" />
                <span v-if="link.class==='experiences-hamburger' || 'exquisite-hamburger'" :class="link.span" alt="Experiences logo" />
              </li>
            </ul>
          </div>
          <div class="" />
        </div>

        <!-- row 3 -->
        <div class="menu__main--sections-section">
          <div class="">
            <h3 class="menu__title underlined">
              The Thinking Traveller
            </h3>
            <ul>
              <li v-for="link in aboutList" :key="link.id">
                <app-link :id="link.id" :type="link.type" :title="link.text">
                  {{ link.text }}
                </app-link>
              </li>
            </ul>
          </div>
          <div class="">
            <h3 class="menu__title underlined">
              Secure Client Area
            </h3>
            <ul>
              <li v-if="isLoggedIn">
                <app-link :id="this.$store.state.pages.dashboardPageId" type="page">
                  My dashboard
                </app-link>
              </li>
              <li v-if="isLoggedIn">
                <a href="/" @click.prevent="logout">Log out</a>
              </li>
              <li v-if="!isLoggedIn">
                <app-link :id="this.$store.state.pages.loginPageId" type="page">
                  Login
                </app-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      topList: [
        {
          text: 'Browse all villas',
          type: 'page',
          id: 16,
        },
        {
          text: 'View / send shortlist',
          type: 'page',
          id: 41,
        },
        {
          text: 'Make an enquiry',
          type: 'page',
          id: 43,
        },
      ],
      mainList: [
        {
          name: 'Destinations',
          id: 1,
          links: [
            {
              text: 'Sicily',
              type: 'page',
              id: 26,
            },
            {
              text: 'Puglia',
              type: 'page',
              id: 28,
            },
            {
              text: 'Tuscan Islands',
              type: 'page',
              id: 835,
            },
            {
              text: 'Greece',
              type: 'page',
              id: 1087,
            },
            {
              text: 'Corsica',
              type: 'page',
              id: 30,
            },
            // {
            //   text: 'Mallorca',
            //   type: 'page',
            //   id: 943,
            // },
          ],
        },
        {
          name: 'Villa inspiration',
          id: 2,
          links: [
            {
              text: 'Villas with a pool',
              type: 'collection',
              id: 440,
            },
            {
              text: 'Villas by the beach',
              type: 'collection',
              id: 518,
            },
            {
              text: 'Exclusive luxury villas',
              type: 'collection',
              id: 439,
            },
            {
              text: 'Villas for large groups',
              type: 'collection',
              id: 441,
            },
            {
              text: 'Villas for couples',
              type: 'collection',
              id: 603,
            },
          ],
        },
        {
          name: 'Guides',
          id: 3,
          links: [
            {
              text: 'Travel Notes blog',
              type: 'page',
              id: 1049,
            },
            {
              text: 'Sicily',
              type: 'page',
              id: 33,
            },
            {
              text: 'Puglia',
              type: 'page',
              id: 34,
            },
            // {
            //   text: 'Tuscan Islands',
            //   type: 'page',
            //   id: 846
            // },
            // Temporarily removed until page is updated - card #1015
            {
              text: 'Corfu',
              type: 'page',
              id: 118,
            },
            // {
            //   text: 'Paxos & Antipaxos',
            //   type: 'page',
            //   id: 445
            // },
            // {
            //   text: 'Meganissi',
            //   type: 'page',
            //   id: 446
            // },
            // {
            //   text: 'Kastos',
            //   type: 'page',
            //   id: 447
            // },
            // {
            //   text: 'Lefkada',
            //   type: 'page',
            //   id: 448
            // },
            // {
            //   text: 'Alonissos',
            //   type: 'page',
            //   id: 449
            // },
            // {
            //   text: 'Skopelos',
            //   type: 'page',
            //   id: 450
            // },
            // {
            //   text: 'Zakynthos',
            //   type: 'page',
            //   id: 994
            // },
            {
              text: 'Corsica',
              type: 'page',
              id: 36,
            },
            // {
            //   text: 'Mallorca',
            //   type: 'page',
            //   id: 944,
            // },
          ],
        },
        {
          name: 'Unique experiences',
          id: 4,
          links: [
            {
              text: 'Wellness holidays',
              type: 'blog',
              id: 85,
            },
            {
              text: 'Cookery retreat with C. Puglisi',
              type: 'page',
              id: 840,
            },
            {
              text: 'Cooking retreat with Michael Tusk',
              type: 'page',
              id: 1143,
            },
            {
              text: 'Experiences',
              type: 'page',
              id: 40,
            },
          ],
        },
        // {
        // name: 'Unique events',
        // id: 7,
        // links: [
        // {
        //   text: 'Weddings',
        //   type: 'collection',
        //   id: 230,
        // },
        // {
        //   text: 'Special celebrations',
        //   type: 'page',
        //   id: 549,
        // },
        // ],
        // },
        // There always has to be 6 arrays of objects
        // TODO find a way to make these both titles with subtitles and logos
        {
          name: '',
          id: 6,
          links: [
            {
              text: 'Think Exquisite',
              type: 'page',
              class: 'exquisite-hamburger',
              id: 39,
              span: 'exquisite-logo-desktop',
            },
            {
              text: 'Our finest luxury villas<br><br>',
              type: 'page',
              id: 39,
            },
            {
              text: '',

            },
            {
              text: 'Experiences',
              type: 'page',
              class: 'experiences-hamburger',
              id: 40,
              // span: 'experiences-logo-desktop'
            },
            {
              text: 'Holiday-enriching activities',
              type: 'page',
              id: 40,
            },
          ],
        },
      ],
      aboutList: [
        {
          text: 'About us',
          type: 'page',
          id: 47,
        },
        // {
        //   text: 'Meet the team',
        //   type: 'page',
        //   id: 68,
        // },
        {
          text: 'Why travel with us',
          type: 'page',
          id: 64,
        },
        {
          text: 'Client reviews',
          type: 'page',
          id: 96,
        },
        {
          text: 'How to book',
          type: 'page',
          id: 44,
        },
        {
          text: 'Make an enquiry',
          type: 'page',
          id: 43,
        },
        // {
        //  text: 'Request a brochure',
        //  type: 'page',
        //  id: 42,
        // },
        {
          text: 'Contact us',
          type: 'page',
          id: 46,
        },
        {
          text: 'Sustainability and us',
          type: 'page',
          id: 843,
        },
        {
          text: 'LGBTQ friendly holidays',
          type: 'page',
          id: 842,
        },
        {
          text: 'FAQ',
          type: 'page',
          id: 49,
        },
      ],
    };
  },
  computed: {
    isDesktop() {
      return this.$store.getters['common/getScreenType'] === 'desktop';
    },
    isLoggedIn(e) {
      return this.$store.getters['users/loggedInUser'] || false;
    },
    isSearchwide() {
      return this.$store.getters['common/getSearchwide'] || false;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('users/logOut');
    },
  },
};
</script>

<style lang="scss" scoped>

@import "../../../assets/styles/settings/config.scss";

@include tablet-up {
  .menu {
    width: 100%;

    .wrapper {
      max-width: 977px;
      margin: 0 auto;
      padding: 25px 12px;
    }

    &__title {
      color: $darkBlack;
      font-size: 1rem;
      font-weight: 500;
      line-height: 1rem;
      padding-bottom: 5px;
      margin: 10px 0 5px;
      font-family: $font-family-editorial;
      &.underlined {
        border-bottom: 1px solid #dcdcdc;
      }
      a {
        color: $darkBlack;
      }

    }

    &__top {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px 0;
      flex-direction: row;

      &--section {
        width: 100%;
        text-align: center;

        &-list {
          &-item {
            flex-grow: 1;
            width: 33%;
            max-width: 300px;
            padding: 0 10px;
            color: $mortar;
            font-weight: 500;
            font-size: 0.875rem;
          }
        }
      }
    }

    &__main {
      display: grid;
      grid-template-columns: 3fr 1fr;
      ul {
        li {
          a {
            color: $mortar;
            font-size: 0.875rem;
            font-weight: 500;
          }
        }
      }
      &--sections {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        &-section {
          padding: 0 20px;
          border-left: 1px solid #dcdcdc;
          &:first-child,
          &:nth-child(4) {
            border: 0;
          }
        }

      }
    }
  }
}

.exquisite-hamburger,
.experiences-hamburger {
  color: $darkBlack !important;
  font-size: 1rem !important;;
  font-weight: 600 !important;;
  line-height: 1rem;
  font-family: $font-family-editorial;
  background-repeat: no-repeat;
  width: 34px;
  background-size: contain;
  background-position: left;

}
.exquisite-logo-desktop {
  background-image: url(../../../assets/img/src/icons/t-exquisite-logo.svg);
    width: 34px;
    height: 35px;
    display: inline-block;
    margin: 0 0 0 5px;
    position: relative;
    @media (min-width: 807px) {
      top: 25px;
      left: 10px;
    }
}

// .experiences-logo-desktop {
//   background-image: url(../../../assets/img/src/logos/think-experiences-logo.svg);
//   width: 47px;
//   height: 24px;
//   display: inline-block;
//   margin: 0 5px 0 0;
//   position: relative;
//   top: 10px;
// }

</style>
